// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__6-kto","link":"NotFound_link__D0B5M"};